import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';

type PerioExamCarouselButtonType = 'back' | 'next';

@Component({
  selector: 'lib-perio-exam-carousel-button',
  imports: [SvgIconComponent],
  templateUrl: './perio-exam-carousel-button.component.html',
  styleUrl: './perio-exam-carousel-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class PerioExamCarouselButtonComponent {
  public type = input.required<PerioExamCarouselButtonType>();
  public buttonClick = output<void>();

  protected iconKey = computed(() => (this.type() === 'back' ? 'px-24-arrow-left-1' : 'px-24-arrow-right-1'));

  protected onButtonClick(): void {
    this.buttonClick.emit();
  }
}
